import request from '@/utils/request'


// 查询赛事分享记录列表
export function listCompetitionShare(query) {
  return request({
    url: '/platform/competition-share/list',
    method: 'get',
    params: query
  })
}

// 查询赛事分享记录分页
export function pageCompetitionShare(query) {
  return request({
    url: '/platform/competition-share/page',
    method: 'get',
    params: query
  })
}

// 查询赛事分享记录分页
export function pageCompetitionShareTwo(query) {
  return request({
    url: '/platform/competition-share/pageTwo',
    method: 'get',
    params: query
  })
}


// 查询赛事分享记录详细
export function getCompetitionShare(data) {
  return request({
    url: '/platform/competition-share/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事分享记录
export function addCompetitionShare(data) {
  return request({
    url: '/platform/competition-share/add',
    method: 'post',
    data: data
  })
}

// 修改赛事分享记录
export function updateCompetitionShare(data) {
  return request({
    url: '/platform/competition-share/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事分享记录
export function delCompetitionShare(data) {
  return request({
    url: '/platform/competition-share/delete',
    method: 'post',
    data: data
  })
}
